import store from '../store/store'
import axios from '../axios'

export default class ActivityService {

  // getMyActivities(userId) {
  //   return new Promise(async function(resolve, reject) {
  //     try {
  //       var path = '/v1/userActivities/' + userId
  //       var response = await axios.get(path)
  //       // 
  //       resolve(response.data)
  //     } catch (err) {
        
  //       reject(err)
  //     }
  //   })
  // }
  

  updateActivityStatus(activityId, body) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/updateActivityStatus/' + activityId
        var response = await axios.put(path, body)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  

  getMyActivities(filterId, page, rows, sortField, sortOrder, searchText, filterbody) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/activityfilterbypage/' + filterId + '/' + page + '/' +  rows + '/' +  sortField + '/' +  sortOrder + '/' + searchText
        var response = await axios.post(path, filterbody)
        // 
        resolve(response)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  
  getActivities(filterId, page, rows, sortField, sortOrder, searchText, filterbody) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/myactivityfilterbypage/' + filterId + '/' + page + '/' +  rows + '/' +  sortField + '/' +  sortOrder + '/' + searchText
        var response = await axios.post(path, filterbody)
        // 
        resolve(response)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getActivity(activityId) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/activity/' + activityId
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  activityGlobalSearch(searchText) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/activityGlobalSearch/' + searchText
        
        var response = await axios.get(path)
        // 
        resolve(response)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getSavedFilteredActivities(id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path
        var path = '/v1/savedFilteredActivities/' + id
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getActivityHistory(activityId) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/recordHistoryActivity/' + activityId
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  // RT1: Delete on the Task & Event settings lists: list is reminderTypes, activityTypes,
  // activityStatuses or activityResults
  deleteSetting(list, id) {
    return new Promise(async (resolve, reject) => {
      try {
        var response = await axios.delete('/v1/' + list + '/' + id)
        resolve(response.data)
      } catch (err) {
        reject(err)
      }
    })
  }
  editReminderType(reminderType) {
    return new Promise(async (resolve, reject) => {
      try {
        if (!reminderType.id) {
          throw new Error('Id must be available for editing.')
        } else {
          var path = '/v1/reminderTypes/' + reminderType.id
          
          var response = await axios.put(path, reminderType)
          // 
          resolve(response.data)
        }
      } catch (err) {
        
        reject(err)
      }
    })
  }

  saveReminderType(reminderType) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/reminderTypes'
        
        var response = await axios.post(path, reminderType)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  editActivityType(activityType) {
    return new Promise(async (resolve, reject) => {
      try {
        if (!activityType.id) {
          throw new Error('Id must be available for editing.')
        } else {
          var path = '/v1/activityTypes/' + activityType.id
          
          var response = await axios.put(path, activityType)
          // 
          resolve(response.data)
        }
      } catch (err) {
        
        reject(err)
      }
    })
  }

  saveActivityType(activityType) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/activityTypes'
        
        var response = await axios.post(path, activityType)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  editActivityStatus(activityStatus) {
    return new Promise(async (resolve, reject) => {
      try {
        if (!activityStatus.id) {
          throw new Error('Id must be available for editing.')
        } else {
          var path = '/v1/activityStatuses/' + activityStatus.id
          
          var response = await axios.put(path, activityStatus)
          // 
          resolve(response.data)
        }
      } catch (err) {
        
        reject(err)
      }
    })
  }

  saveActivityStatus(activityStatus) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/activityStatuses'
        
        var response = await axios.post(path, activityStatus)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  editActivityResult(activityResult) {
    return new Promise(async (resolve, reject) => {
      try {
        if (!activityResult.id) {
          throw new Error('Id must be available for editing.')
        } else {
          var path = '/v1/activityResults/' + activityResult.id
          
          var response = await axios.put(path, activityResult)
          // 
          resolve(response.data)
        }
      } catch (err) {
        
        reject(err)
      }
    })
  }

  saveActivityResult(activityResult) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/activityResults'
        
        var response = await axios.post(path, activityResult)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  //MBP
  getAllActivities() {
    return new Promise(async function (resolve, reject) {
      try {
        var path = '/v1/activities'
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  saveActivity(activity) {
    return new Promise(async function (resolve, reject) {
      try {
        
        var path = '/v1/activity'
        
        var response = await axios.post(path, activity)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  updateActivity(id, activity) {
    return new Promise(async function (resolve, reject) {
      try {
        
        var path = '/v1/activity/' + id
        
        var response = await axios.put(path, activity)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  // G6: a follow-up from a task or event, at any time; resolves with the new record's id
  createFollowUp(id, followUp) {
    return axios.post('/v1/activity/' + id + '/followUp', followUp).then(response => response.data)
  }

  // G5: saves an event's meeting notes and nothing else
  updateMeetingNotes(id, meetingNotes) {
    return axios.put('/v1/activity/' + id + '/meetingNotes', { meetingNotes }).then(response => response.data)
  }

  deleteActivity(id) {
    return new Promise(async function (resolve, reject) {
      try {
        
        var path = '/v1/activity/' + id
        
        var response = await axios.delete(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  // Get all Customer LOV Data
  getAllActivityTypesByHard() {
    return new Promise(async function (resolve, reject) {
      try {
        var path = '/v1/activityTypes'
        
        var response = await axios.get(path)
        
        try {
          store.dispatch(`commons/activityTypes`, response.data)
        } catch(e) {}
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  getAllActivityTypes() {
    return new Promise(async function (resolve, reject) {
      if (store.getters[`commons/activityTypes`]) {
        resolve(store.getters[`commons/activityTypes`])
  
      } else {
        try {
          var path = '/v1/activityTypes'
          
          var response = await axios.get(path)
          
          try {
            store.dispatch(`commons/activityTypes`, response.data)
          } catch(e) {}
          
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })
  }
  getAllActiveActivityTypesByHard() {
    return new Promise(async function (resolve, reject) {
      try {
        var path = '/v1/activeactivitytypes'
        
        var response = await axios.get(path)
        
        try {
          store.dispatch(`commons/activeactivitytypes`, response.data)
        } catch(e) {}
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getAllActiveActivityTypes() {
    return new Promise(async function (resolve, reject) {
      if (store.getters[`commons/activeactivitytypes`]) {
        resolve(store.getters[`commons/activeactivitytypes`])
  
      } else {
        try {
          var path = '/v1/activeActivityTypes'
          
          var response = await axios.get(path)
          
          try {
            store.dispatch(`commons/activeactivitytypes`, response.data)
          } catch(e) {}
          
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })
  }

  getAllActivityResultsByHard() {
    return new Promise(async function (resolve, reject) {
      try {
        var path = '/v1/activityResults'
        
        var response = await axios.get(path)
        
        try {
          store.dispatch(`commons/activityresults`, response.data)
        } catch(e) {}
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  getAllActivityResults() {
    return new Promise(async function (resolve, reject) {
      if (store.getters[`commons/activityresults`]) {
        resolve(store.getters[`commons/activityresults`])
  
      } else {
        try {
          var path = '/v1/activityResults'
          
          var response = await axios.get(path)
          
          try {
            store.dispatch(`commons/activityresults`, response.data)
          } catch(e) {}
          
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })
  }

  getAllActiveActivityResultsByHard() {
    return new Promise(async function (resolve, reject) {
      try {
        var path = '/v1/activeactivityresults'
        
        var response = await axios.get(path)
        
        try {
          store.dispatch(`commons/activeactivityresults`, response.data)
        } catch(e) {}
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getAllActiveActivityResults() {
    return new Promise(async function (resolve, reject) {
      if (store.getters[`commons/activeactivityresults`]) {
        resolve(store.getters[`commons/activeactivityresults`])
  
      } else {
        try {
          var path = '/v1/activeActivityResults'
          
          var response = await axios.get(path)
          
          try {
            store.dispatch(`commons/activeactivityresults`, response.data)
          } catch(e) {}
          
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })
  }

  getAllActivityStatusesByHard() {
    return new Promise(async function (resolve, reject) {
      try {
        var path = '/v1/activityStatuses'
        
        var response = await axios.get(path)

        try {
          store.dispatch(`commons/activitystatuses`, response.data)
        } catch(e) {}

        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })

  }
  getAllActivityStatuses() {
    return new Promise(async function (resolve, reject) {
      if (store.getters[`commons/activitystatuses`]) {
        resolve(store.getters[`commons/activitystatuses`])
  
      } else {
        try {
          var path = '/v1/activityStatuses'
          
          var response = await axios.get(path)
  
          try {
            store.dispatch(`commons/activitystatuses`, response.data)
          } catch(e) {}
  
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })

  }

  getAllActiveActivityStatusesByHard() {
    return new Promise(async function (resolve, reject) {
      try {
        var path = '/v1/activeActivityStatuses'
        
        var response = await axios.get(path)

        try {
          store.dispatch(`commons/activeactivitystatuses`, response.data)
        } catch(e) {}

        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })

  }

  getAllActiveActivityStatuses() {
    return new Promise(async function (resolve, reject) {
      if (store.getters[`commons/activeactivitystatuses`]) {
        resolve(store.getters[`commons/activeactivitystatuses`])
  
      } else {
        try {
          var path = '/v1/activeActivityStatuses'
          
          var response = await axios.get(path)
  
          try {
            store.dispatch(`commons/activeactivitystatuses`, response.data)
          } catch(e) {}
  
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })

  }

  getAllReminderTypes() {
    return new Promise(async function (resolve, reject) {
      try {
        var path = '/v1/reminderTypes'
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getAllActiveReminderTypesByHard() {
    return new Promise(async function (resolve, reject) {
      try {
        var path = '/v1/activeReminderTypes'
        
        var response = await axios.get(path)

        try {
          store.dispatch(`commons/activeReminderTypes`, response.data)
        } catch(e) {}

        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })

  }

  getAllActiveReminderTypes() {
    return new Promise(async function (resolve, reject) {
      if (store.getters[`commons/activeremindertypes`]) {
        resolve(store.getters[`commons/activeremindertypes`])
  
      } else {
        try {
          var path = '/v1/activeReminderTypes'
          
          var response = await axios.get(path)
          
          try {
            store.dispatch(`commons/activeremindertypes`, response.data)
          } catch(e) {}
          
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })
  }

  getAllActivitiesOppotunity(id) {
    return new Promise(async function (resolve, reject) {
      try {
        var path = '/v1/opportunityactivities/' + id
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

}
